import ButtonBack from '@/components/_common/ButtonBack';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { Button, FormInstance } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import DiagnosticReportModal from '../DiagnosticReportModal';
import { useDisclosure } from '@/hooks';
import {
  Diagnostic,
  DiagnosticFormValues,
} from '@/core/domain/workorder/Diagnostics/Diagnostics.types';
import DiagnosticGenerateBudgetModal from '@/components/Movements/Diagnostics/DiagnosticGenerateBudgetModal';
import { WorkorderChecklistItemType } from '@/components/Movements/WorkOrders/WorkorderChecklist/WorkorderChecklistProvider/WorkorderChecklistProvider.types';
import { useWorkOrder } from '@/core/domain/workorder/WorkOrders/WorkOrders.hooks';

interface Props {
  disabled: boolean;
  diagnostic?: Diagnostic;
  form: FormInstance<DiagnosticFormValues>;
}

const DiagnosticFooter: React.FC<Props> = ({ disabled, diagnostic, form }) => {
  const history = useHistory();

  const [reportModalVisible, reportModalAction] = useDisclosure();
  const [generateBudgetModal, generateBudgetModalAction] = useDisclosure();

  const { data } = useWorkOrder(diagnostic?.workOrderId);

  return (
    <>
      <SpaceForButton>
        <ButtonBack path="/app/movements/diagnostics" disabled={disabled} />

        {diagnostic?.generateWorkOrder ? (
          <Button
            type="primary"
            block
            onClick={() =>
              window.open(
                `/app/movements/workOrders/${data?.id}/complements/${data?.complements[0].id}/generalInfo`,
                '_blank',
              )
            }
          >
            Orçamento
          </Button>
        ) : (
          <Button
            type="primary"
            onClick={() => generateBudgetModalAction.open()}
            block
          >
            <FormattedMessage id="commons.page.button.generateBudget" />
          </Button>
        )}

        <Button
          type="primary"
          disabled={diagnostic?.generateWorkOrder}
          block
          onClick={() =>
            history.push(
              `/app/movements/workorderChecklist/${diagnostic?.id}/damages?checklistItemType=${WorkorderChecklistItemType.Diagnostic}&checklistItemId=${diagnostic?.id}&diagnosticId=${diagnostic?.id}`,
            )
          }
        >
          <FormattedMessage id="commons.page.button.Checklist" />
        </Button>

        <Button type="primary" onClick={reportModalAction.open} block>
          <FormattedMessage id="commons.page.button.generateReport" />
        </Button>
      </SpaceForButton>

      <DiagnosticReportModal
        visible={reportModalVisible}
        handleVisible={reportModalAction.toggle}
      />

      <DiagnosticGenerateBudgetModal
        diagnostic={diagnostic}
        companyId={form.getFieldValue('companyId')}
        open={generateBudgetModal}
        onCancel={generateBudgetModalAction.close}
      />
    </>
  );
};

export default DiagnosticFooter;
